export const generateUniqueActivityKey = (
    activityCode: string, 
    relationship: string, 
    ageRange: string,
    selectedPlan: string,
): string => `${ activityCode }-${ relationship }-${ ageRange }-${ selectedPlan }`;

export const generateInputName = (
    coverageDescription: string, 
    activityKey: string, 
    prefix: 'sumaAsegurada' | 'prima' | 'checkbox' = 'sumaAsegurada'
) => `${ prefix }_${ coverageDescription?.toLowerCase().split(' ').join('_') }_${ activityKey }`;

export const generateInputID = (
    id: string, 
    activityKey: string, 
    prefix: 'sumaAsegurada' | 'prima' | 'checkbox' = 'sumaAsegurada'
) => `${ prefix }_${ id }_${ activityKey }`;

export const getCoverageAndActivityKeyByID = (
    inputName: string 
): { activityKey: string, id: string, prefix: 'sumaAsegurada' | 'prima' | 'checkbox' } => {

    const parts = inputName.split('_');

    const prefix = parts[0] as 'sumaAsegurada' | 'prima' | 'checkbox';
    const id = parts[1];
    const activityKey = parts[2];

    return { prefix, id, activityKey };
};

export const getCoverageAndActivityKey = (
    inputName: string 
): { activityKey: string, coverageDescription: string, prefix: 'suma' | 'prima' | 'checkbox' } => {

    let start: number;
    const parts = inputName.split('_');

    const prefix: 'suma' | 'prima' | 'checkbox' = parts[0] as 'suma' | 'prima' | 'checkbox';

    if( prefix === 'suma' ) {
        start = 2
    } else {
        start = 1
    }

    const activityKey = parts[parts.length - 1];

    const coverageDescription = parts.slice(start, -1).join(' ');

    return { activityKey, coverageDescription, prefix };
}

export const getActivitiesCodeFromError = ( errorFields: Array<{ errors: Array<string>, name: Array<string>, warnings: Array<string> }> ): Array<string> => {
    let activitiesCodes: Array<string> = [];

    errorFields.forEach(({ name }) => {
        const { activityKey } = getCoverageAndActivityKey( name[0] ); //! TODO: Reemplazar por getCoverageAndActivityKeyByID
        
        const activityCode = activityKey.split('-')[0];

        activitiesCodes.push( activityCode );
    })

    return activitiesCodes
}

export const getActivitiesErrorMessage = ( activityCodes: Array<string> ): string => {
    if ( activityCodes.length === 0 ) return 'Debe completar todos los campos';
    if ( activityCodes.length === 1 ) return `Se encontraron errores en la actividad ${ activityCodes[activityCodes.length - 1] }`;

    const filterActivityCodes = activityCodes.filter((item, index) => activityCodes.indexOf(item) === index);;

    let activities: string = filterActivityCodes.slice(0, -1).join(', ');
    return `Se encontraron errores en las actividades ${ activities } y ${ activityCodes[activityCodes.length - 1] }`;
}